import { Component } from 'utils/jsx'
import { writable } from 'utils/state'

import cuid from 'cuid'
import classnames from 'classnames'

export default class Checkbox extends Component {
  beforeRender (props) {
    this.handleInput = this.handleInput.bind(this)

    this.state = {
      id: props.id || cuid(),
      checked: props['store-checked']
        ? props['store-checked']
        : writable(props.checked),
      indeterminate: props['store-indeterminate']
        ? props['store-indeterminate']
        : writable(props.indeterminate),
      disabled: props['store-disabled']
        ? props['store-disabled']
        : writable(props.disabled),
      hidden: props['store-hidden']
        ? props['store-hidden']
        : writable(props.hidden)
    }
  }

  template (props) {
    return (
      <div
        class={classnames('checkbox', props.class)}
        store-class-is-disabled={this.state.disabled}
        store-class-is-hidden={this.state.hidden}
        store-class-is-checked={this.state.checked}
        store-class-is-inderterminate={this.state.inderterminate}
      >
        <input
          type='checkbox'
          id={this.state.id}
          title={props.title}
          ref={this.ref('input')}
          event-input={this.handleInput}
          store-checked={this.state.checked}
          store-indeterminate={this.state.indeterminate}
        />
        {
          props.children &&
            <label for={this.state.id}>{props.children}</label>
        }
      </div>
    )
  }

  handleInput (e) {
    this.state.checked.set(this.refs.input.checked)
    this.state.indeterminate.set(this.refs.input.indeterminate)
    if (this.props['event-input']) this.props['event-input'](e)
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Checkbox.js